import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "left_menu" }
const _hoisted_2 = ["onClick"]

import { ref, toRefs, watchEffect } from 'vue'
    import {RectAreaLightUniformsLib} from "three/examples/jsm/lights/RectAreaLightUniformsLib";
    import init = RectAreaLightUniformsLib.init;

    
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
        tagNameList: Array,
        listName: String
    },
  emits: ['clickChild'],
  setup(__props, { expose: __expose, emit: __emit }) {

    const props = __props

    const { tagNameList,listName } = toRefs(props) as any
    let nuewTagList = ref([]) as any

    let selectTagId = ref('')

    const emit = __emit
    const clickChild=(item:any)=>{
        selectTagId.value = item?.id
        emit('clickChild',item?.listLabel,item?.listName)
    }
    const formateTagList = (tag:[]) => {
        tag.forEach((res:any) => {
            console.log('res',res);
            //  这两个类型的事项不在这里显示
            // if(!(res.listLabel === '一业一证' || res.listLabel === '智能秒办')){
            //     nuewTagList.value.push(res)
            // }
            nuewTagList.value.push(res)
        });
        console.log('nuewTagList.value',nuewTagList.value);
    }
    watchEffect(()=>{
        let tag = tagNameList.value
        formateTagList(tag)
        console.log('listName',listName.value);
        if(listName.value !=null && listName.value !='' ){
          nuewTagList.value.forEach((res:any) => {
            if(res.listName === listName.value){
              clickChild(res)
            }
          })
            // clickChild(nuewTagList.value[1])
        }else{
            clickChild(nuewTagList.value[0])

        }
    })



    __expose({
        clickChild
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nuewTagList), (item) => {
      return (_openBlock(), _createElementBlock("a", {
        class: _normalizeClass(["tit", {'active':_unref(selectTagId) === item.id}]),
        onClick: ($event: any) => (clickChild(item)),
        key: item.id
      }, _toDisplayString(item.listLabel), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})